import React from 'react';
import DSImageLibraryModal from '@elliemae/ds-imagelibrarymodal';
import PropTypes from 'prop-types';

export default class ImageLibraryModal extends React.PureComponent {
  static propTypes = {
    onConfirm: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onReject: PropTypes.func,
    imagesData: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        url: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        description: PropTypes.string,
        createdBy: PropTypes.string.isRequired,
        createdDate: PropTypes.string.isRequired,
      }),
    ),
    isOpen: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    onReject: undefined,
    imagesData: [
      {
        url: 'https://www.freeiconspng.com/minicovers/no-image-icon-6.png',
        name: 'no image',
        createdBy: 'user:John Doe',
        createdDate: '0000-01-01 00:00 AM UTC',
      },
      {
        url:
          'https://asset-service-bucket-int.s3.us-west-2.amazonaws.com/bd527d8c-472f-4dff-b8c5-1c90d5bae01e',
        name: 'no image 2',
        createdBy: 'user:Jane Doe',
        createdDate: '0000-01-01 00:00 AM UTC',
      },
    ],
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedImage: undefined,
    };
  }

  onSelect = selectedImage => {
    this.setState({ selectedImage });
  };

  onConfirm = () => {
    const { selectedImage } = this.state;
    const { onConfirm, onClose } = this.props;
    onConfirm(selectedImage);
    onClose();
  };

  render() {
    return (
      <DSImageLibraryModal
        {...this.props}
        onConfirm={this.onConfirm}
        onSelect={this.onSelect}
      />
    );
  }
}
